
class SmokeParticle {
  constructor(pCont, maxH, iAlpha) {
    // const
    this.pCont = pCont;
    this.maxH = -maxH;
    this.iAlpha = iAlpha;

    // parts
    this.ptc = null;

    // vars
    this.vX = 0.0;
    this.vY = 0.0;
    this.vS = 0.0;
    this.vR = 0.0;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    this.ptc = new PIXI.Sprite.fromFrame(`p-smoke-${1 + Math.round(Math.random() * 2)}.png`);
    this.ptc.anchor.x = 0.5;
    this.ptc.anchor.y = 0.5;
    this.pCont.addChild(this.ptc);

    // init setup
    this.resetPt();

    // set init random y
    this.ptc.y = Math.random() * this.maxH;
    const posValue = (-this.ptc.y) / this.vY;

    this.ptc.x -= this.vX * posValue;
    this.ptc.scale.x += this.vS * posValue;
    this.ptc.scale.y = this.ptc.scale.x;
  }

  // --------------------------------------------------------------
  // Reset
  // --------------------------------------------------------------

  resetPt() {
    this.ptc.x = 0;
    this.ptc.y = 0;
    this.ptc.rotation = Math.random() * Math.PI * 2;
    this.ptc.alpha = this.iAlpha;
    this.ptc.scale.x = 0.2;
    this.ptc.scale.y = 0.2;
    this.vX = (-0.02 + (Math.random() * 0.1)) * 0.5;
    this.vY = 0.09 + (Math.random() * 0.09);
    this.vS = (0.0007 + (Math.random() * 0.0003)) * 0.5;
    this.vR = -0.01 + (Math.random() * 0.02);
  }

  // --------------------------------------------------------------
  // Update
  // --------------------------------------------------------------

  lUp() {
    this.ptc.x -= this.vX;
    this.ptc.y -= this.vY;
    this.ptc.rotation += this.vR;
    this.ptc.alpha = this.iAlpha * (1 - (this.ptc.y / this.maxH));

    this.ptc.scale.x += this.vS;
    this.ptc.scale.y = this.ptc.scale.x;

    if (this.ptc.y < this.maxH) {
      this.resetPt();
    }
  }
}

export default SmokeParticle;



// WEBPACK FOOTER //
// ./src/js/scene/parts/town/parts/SmokeParticle.js